<template>
  <div>
    <the-nav-bar :title="isEdit ? $t('common.edit') : $t('createPost.name')" />
    <div class="body-wrapper">
      <md-scroll-view :scrolling-x="false" :auto-reflow="true" ref="scrollView">
        <div class="scroll-body">
          <div class="field">
            <div class="field-item add-switch">
              <div class="row-justify-center" @click="showOptions('adType')">
                <div class="field-item-title">
                  {{ $t('createPost.adType') }}
                </div>
                <div
                  class="field-item-content"
                  :class="{ inactive: !getText('adTypeText') }"
                >
                  {{ getText('adTypeText') || $t('createPost.default') }}
                </div>
                <div class="field-item-right row-center">
                  <md-icon
                    name="arrow-right"
                    size="sm"
                    color="#84969C"
                  ></md-icon>
                </div>
              </div>
              <div class="switch" v-if="adTemp.adType === 'sell'">
                <p class="brief">{{ $t('createPost.optionalModeBrief') }}</p>
                <div class="row-justify-center">
                  <div class="field-item-title row-align-center">
                    <span>{{ $t('createPost.optionalMode') }}</span>
                  </div>
                  <div class="field-item-content col-align-end">
                    <div class="switch" @click="onSwitchChange">
                      <md-switch v-model="isCheck"></md-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="field-item row-justify-center"
              @click="showOptions('attribute')"
            >
              <div class="field-item-title">
                {{ $t('createPost.attribute') }}
              </div>
              <div
                class="field-item-content"
                :class="{ inactive: !getText('attributeText') }"
              >
                {{ getText('attributeText') || $t('createPost.default') }}
              </div>
              <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div>
            </div>
            <div
              class="field-item row-justify-center"
              @click="showOptions('crypto')"
            >
              <div class="field-item-title">
                {{ $t('createPost.crypto') }}
              </div>
              <div
                class="field-item-content"
                :class="{ inactive: !getText('cryptoText') }"
              >
                {{ getText('cryptoText') || $t('createPost.default') }}
              </div>
              <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div>
            </div>
            <div
              class="field-item row-justify-center"
              @click="showOptions('payment')"
            >
              <div class="field-item-title">
                {{ $t('createPost.payment') }}
              </div>
              <div
                class="field-item-content"
                :class="{ inactive: !getText('paymentText') }"
              >
                {{ getText('paymentText') || $t('createPost.default') }}
              </div>
              <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div>
            </div>
            <div
              class="field-item row-justify-center"
              @click="showOptions('fiatCurrency')"
            >
              <div class="field-item-title">
                {{ $t('createPost.fiatCurrency') }}
              </div>
              <div
                class="field-item-content"
                :class="{ inactive: !getText('fiatCurrencyText') }"
              >
                {{ getText('fiatCurrencyText') || $t('createPost.default') }}
              </div>
              <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div>
            </div>
            <div
              class="field-item row-justify-center"
              @click="showOptions('customizePrice')"
            >
              <div class="field-item-title">
                {{ $t('createPost.customizePrice') }}
              </div>
              <div
                class="field-item-content"
                :class="{ inactive: !getText('customizePriceText') }"
              >
                {{ getText('customizePriceText') || $t('createPost.default') }}
              </div>
              <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div>
            </div>
            <div
              class="field-item row-justify-center"
              @click="showOptions('tradeAmount')"
            >
              <div class="field-item-title">
                {{ $t('createPost.tradeAmount') }}
              </div>
              <div
                class="field-item-content"
                :class="{ inactive: !getText('tradeAmountText') }"
              >
                {{ getText('tradeAmountText') || $t('createPost.default') }}
              </div>
              <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div>
            </div>
            <div
              class="field-item row-justify-center"
              @click="showOptions('location')"
            >
              <div class="field-item-title">
                {{ $t('createPost.location') }}
              </div>
              <div
                class="field-item-content"
                :class="{ inactive: !getText('locationText') }"
              >
                {{ getText('locationText') || $t('createPost.default') }}
              </div>
              <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div>
            </div>
            <div
              class="field-item row-justify-center"
              @click="showOptions('standardHours')"
            >
              <div class="field-item-title">
                {{ $t('createPost.standardHours') }}
              </div>
              <div
                class="field-item-content"
                :class="{ inactive: !getText('standardHoursText') }"
              >
                {{ getText('standardHoursText') || $t('createPost.default') }}
              </div>
              <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div>
            </div>
            <div
              class="field-item row-justify-center"
              v-if="settings && settings.property && settings.property.length"
              @click="showOptions('trader')"
            >
              <div class="field-item-title">
                {{ $t('createPost.trader') }}
              </div>
              <div
                class="field-item-content"
                :class="{ inactive: !getText('traderText') }"
              >
                {{ getText('traderText') || $t('createPost.defaultTrader') }}
              </div>
              <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div>
            </div>
            <!-- <div
              class="field-item row-justify-center"
              v-for="key of fieldItemList"
              :key="key"
              @click="showOptions(key)"
            >
              <div class="field-item-title">{{ $t(`createPost.${key}`) }}</div>
              <div
                class="field-item-content"
                :class="{ inactive: !getText(`${key}Text`) }"
              >
                {{
                  getText(`${key}Text`) ||
                  (key === 'trader'
                    ? $t('createPost.defaultTrader')
                    : $t('createPost.default'))
                }}
              </div>
              <div class="field-item-right row-center">
                <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
              </div>
            </div> -->
          </div>
          <div class="input-panel">
            <div class="input-panel-item">
              <div class="panel-item-title row-align-center">
                <svg class="icon">
                  <use xlink:href="#icon-smile" />
                </svg>
                <span>{{ $t('createPost.headline') }}</span>
              </div>
              <div class="panel-item-content">
                <md-input-item
                  type="text"
                  class="input-item"
                  placeholder="Hi,TIGA"
                  v-model.trim="title"
                  :maxlength="100"
                ></md-input-item>
              </div>
            </div>
            <div class="input-panel-item">
              <div class="panel-item-title row-align-center">
                <svg class="icon">
                  <use xlink:href="#icon-smile" />
                </svg>
                <span>{{ $t('createPost.termsOfTrade') }}</span>
              </div>
              <div class="panel-item-content">
                <md-textarea-item
                  class="textarea-item"
                  v-model="provisions"
                  placeholder="Hi,TIGA"
                  rows="3"
                  clearable
                ></md-textarea-item>
              </div>
            </div>
          </div>
        </div>
      </md-scroll-view>
    </div>
    <div class="btn-wrapper">
      <md-button
        class="btn"
        @click="onSaveBtnClickPre"
        :type="isPostBtnDisabled ? 'disabled' : 'primary'"
      >
        <span v-if="isEdit">{{ $t('common.save') }}</span>
        <span v-else>{{ $t('post.name') }}</span>
      </md-button>
      <md-button
        v-if="isEdit"
        class="btn btn-remove"
        type="primary"
        plain
        @click="onRemoveBtnClick"
      >
        <span>{{ $t('common.remove') }}</span>
      </md-button>
    </div>
    <md-popup v-model="isShowPopup" position="bottom" class="popup">
      <md-popup-title-bar
        only-close
        large-radius
        class="title-bar"
        :title="popupData.title"
        @confirm="hidePopup"
        @cancel="hidePopup"
      />
      <!-- <div class="popup-body"> -->
      <div class="filter" v-if="hasFilter">
        <md-input-item
          v-model.trim="filterKey"
          type="text"
          :placeholder="$t('exchange.filterPlaceholder')"
        >
          <div class="input-item-left row-center" slot="left">
            <md-icon name="search" size="lg" color="currentColor"></md-icon>
          </div>
        </md-input-item>
      </div>
      <div class="scroller">
        <md-scroll-view :scrolling-x="false" auto-reflow class="popup-body">
          <!-- <div
            class="popup-item row-center"
            v-for="(item, index) in popupData.list"
            :key="`popup-item-${popupData.name}-${index}`"
            @click="onChoose(item)"
            :class="{ active: item.value === popupData.value }"
          >
            <div class="text">{{ item.text }}</div>
          </div> -->
          <div
            class="popup-item row-center"
            v-for="(item, index) in newPopupData"
            :key="`popup-item-${popupData.name}-${index}`"
            @click="onChoose(item)"
            :class="{ active: item.value === popupData.value }"
          >
            <div class="text">{{ item.text }}</div>
          </div>
        </md-scroll-view>
      </div>
      <!-- </div> -->
    </md-popup>
    <md-popup v-model="isShowPayMethodPopup" position="bottom" class="popup">
      <!-- 支付方式 -->
      <md-popup-title-bar
        :title="$t('createPost.payment')" 
        large-radius
        class="title-bar"
        :cancel-text="$t('common.cancel')"
        :ok-text="$t('common.confirm')"
        @cancel="onPayMethodPopupCancel"
        @confirm="onPayMethodPopupConfirm"
      />
      <!-- <div class="popup-body"> -->
      <div class="filter" v-if="hasFilter">
        <md-input-item
          v-model.trim="filterKey"
          type="text"
          :placeholder="$t('exchange.filterPlaceholder')"
        >
          <div class="input-item-left row-center" slot="left">
            <md-icon name="search" size="lg" color="currentColor"></md-icon>
          </div>
        </md-input-item>
      </div>
      <div class="scroller">
        <md-check-list
          v-model="selectedTemp"
          @input="onChoosePayment"
          :options="newPaymentList"
          icon="right"
          icon-inverse=""
          class="popup-body"
        ></md-check-list>
      </div>
      <!-- </div> -->
    </md-popup>

        <md-dialog
          :title="this.$t('common.coWarnTitle')"
          :closable="false"
          v-model="lossDialog.open"
          :btns="lossDialog.btns"
        >
            {{$t('common.coWarnText1')}}
            <span style="font-weight:bold;color:red;">
            {{$t('common.coWarnText2')}}
            </span> 
            <span style="color:red;">
            {{$t('common.coWarnText3')}}
            </span>
            <span style="font-weight:bold;">
              {{$t('common.adjustFeeText')}}
            </span>
            <p style="margin-top: 5px;"></p>
              <md-agree
                v-model="agreeConf.checked"
                :disabled="agreeConf.disabled"
                :size="agreeConf.size"
                icon-type="square"
                @change="onAgreeChange(agreeConf.checked, $event)"
              >
                  {{$t('common.knownAgree')}}
                <a style="text-decoration: none;" href="javascript:void(0)" @click="showAgreement()" >《{{ $t('global.login.agreementName') }}》</a>
              </md-agree>
        
        </md-dialog>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Icon,
  ScrollView,
  InputItem,
  TextareaItem,
  Button,
  Popup,
  PopupTitleBar,
  Toast,
  Dialog,
  CheckList,
  Switch,
  Agree,
} from 'mand-mobile';
import { mapState } from 'vuex';
import postNewAd from '@/api/post-new-ad.js';
import putAdEdit from '@/api/put-ad-edit';
import putChangeStatus from '@/api/put-change-status';
export default {
  components: {
    'the-nav-bar': TheNavBar,
    [Icon.name]: Icon,
    [ScrollView.name]: ScrollView,
    [InputItem.name]: InputItem,
    [TextareaItem.name]: TextareaItem,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [Dialog.name]: Dialog,
    [CheckList.name]: CheckList,
    [Switch.name]: Switch,
    [Agree.name]: Agree,
  },
  data() {
    return {
      agreeConf: {
        checked: false,
        name: 'agreeRisk',
        size: 'md',
        disabled: false,
        introduction: '风险须知同意',
      },
      lossDialog: {
        open: false,
        btns: [
          {
            text: this.$t('common.cancel'),
          },
          {
            text: this.$t('common.confirm'),
            warning: true,
            handler: this.onLossConfirm,
          },
        ],
      },
      isEdit: false,
      adId: '',
      title: '',
      provisions: '',
      fieldItemList: [
        'adType',
        'attribute',
        'crypto',
        'payment',
        'fiatCurrency',
        'customizePrice',
        'tradeAmount',
        'location',
        'standardHours',
      ],
      isShowPopup: false,
      popupData: {
        name: '',
        value: '',
        title: '',
        list: [],
      },
      needQuitDialog: true,
      isLoaded: false,
      isShowPayMethodPopup: false,
      selectedTemp: [],
      filterKey: '',
      hasFilter: false,
    };
  },
  computed: {
    ...mapState({
      settings: state => state.settings,
      adTemp: state => state.adTemp,
      adStore: state => state.adStore,
      userInfo: state => state.userInfo,
      navLang: state => state.navLang,
      navLangMain: state => state.navLangMain,
    }),
    isCheck: {
      get() {
        return this.adTemp.isCheck;
      },
      set(val) {
        this.$store.commit('setCreateTemp', { isCheck: val });
      },
    },
    adTypeList() {
      return [
        {
          value: 'buy',
          text: this.$t('createPost.buy'),
        },
        {
          value: 'sell',
          text: this.$t('createPost.sell'),
        },
      ];
    },
    adTypeText() {
      const { adType } = this.adTemp;
      return (adType && this.$t(`createPost.${adType}`)) || '';
    },
    attributeList() {
      return [
        {
          value: 0,
          text: this.$t('createPost.public'),
        },
        {
          value: 1,
          text: this.$t('createPost.private'),
        },
      ];
    },
    attributeText() {
      const { attribute } = this.adTemp;
      const item = this.attributeList.find(item => item.value === attribute);
      return (item && item.text) || '';
    },
    cryptoList() {
      return this.settings.cryptoList.map(item => {
        return {
          value: item.id,
          text: `${item.name} (${item.symbol})`,
        };
      });
    },
    cryptoText() {
      const { crypto } = this.adTemp;
      const obj = this.cryptoList.find(item => {
        return item.value == crypto;
      });
      return (obj && obj.text) || '';
    },
    paymentList() {
      var _this = this;
      var Newitems = [];
      _this.settings.paymentList.forEach(item => {
        if(item.isUse == 1){
          Newitems.push({
            value: item.id,
            label: _this.$t(`payments.${item.name}`),
          });
        }

      });
      return Newitems;
    },
    newPaymentList() {
      var _this = this;
      var Newitems = [];
      _this.paymentList.forEach(item => {
        if (
          item.label.toLowerCase().search(_this.filterKey.toLowerCase()) != -1
        ) {
          Newitems.push({
            value: item.value,
            label: item.label,
          });
        }
      });
      return Newitems;
    },
    paymentText() {
      const { payment } = this.adTemp;
      const arr = [];
      this.paymentList.forEach(item => {
        if (payment.includes(item.value)) {
          arr.push(item.label);
        }
      });
      return this.navLang == 'en' ? arr.join(',') : arr.join('，');
    },
    fiatCurrencyList() {
      var Newitems = [];
      var _this = this;
      _this.settings.legalCurrencyList.forEach(item => {
        if(item.isUse == 1){
          Newitems.push({
            value: item.id,
            text: `${item.name} (${item.unit})`,
          });
        }
      });
      return Newitems;
    },
    fiatCurrencyText() {
      const { fiatCurrency } = this.adTemp;
      const obj = this.fiatCurrencyList.find(item => {
        return item.value == fiatCurrency;
      });
      return (obj && obj.text) || '';
    },
    locationList() {
      return this.settings.locationList.map(item => {
        return {
          value: item.id,
          text: this.$root.countries.getName(item.name, this.navLangMain),
        };
      });
    },
    locationText() {
      const { location } = this.adTemp;
      const obj = this.locationList.find(item => {
        return item.value == location;
      });
      return (obj && obj.text) || '';
    },
    customizePriceText() {
      const {
        isFixed,
        fixedPrice,
        reference,
        isAbove,
        percentage,
        difference,
        // lowestPrice,
      } = this.adTemp;
      if (isFixed) {
        return fixedPrice || '';
      } else {
        if (isAbove === '' || reference === '') {
          return '';
        }
      }
      const { referenceList } = this.settings;
      let str = '';
      let obj = referenceList.find(item => item.id === reference);
      str += isAbove ? this.$t('customize.above') : this.$t('customize.below');
      if (obj && obj.value === 'exinone') {
        str += ` ${this.$t('customize.exinone')} ${difference} CNY`;
      } else {
        str += ` ${obj && obj.text} ${percentage}%`;
      }
      // str += `${lowestPrice} CNY`;
      return str;
    },
    tradeAmountText() {
      const { tradeAmountMin, tradeAmountMax } = this.adTemp;
      if (!tradeAmountMin || !tradeAmountMin) {
        return '';
      }
      return `${tradeAmountMin} - ${tradeAmountMax}`;
    },
    standardHoursText() {
      const { timeZone, timeStart, timeEnd } = this.adTemp;
      const { timeZoneList, timeList } = this.settings;
      if (timeZone === '' || timeStart === '' || timeEnd === '') {
        return '';
      }
      return `${timeZoneList[timeZone].text} ${timeList[timeStart].text}-${timeList[timeEnd].text}`;
    },
    traderText() {
      const { traders } = this.adTemp;
      return traders.length ? this.$t('createPost.selectedTrader') : '';
    },
    isPostBtnDisabled() {
      let disabled = false;
      this.fieldItemList.forEach(key => {
        if (key !== 'trader') {
          disabled = disabled || !this[`${key}Text`];
        }
      });
      return disabled || this.isSubmitting;
    },
    isRemoveBtnDisabled() {
      return this.isSubmitting;
    },
    newPopupData() {
      var _this = this;
      var Newitems = [];
      _this.popupData.list.map(item => {
        if (
          item.text.toLowerCase().search(_this.filterKey.toLowerCase()) != -1
        ) {
          Newitems.push(item);
        }
      });
      return Newitems;
    },
  },
  created() {
    const { path, query } = this.$route;
    if (this.settings.property.length) {
      this.fieldItemList.push('trader');
    }
    if (path === '/post/edit') {
      this.isEdit = true;
      if (
        !query.id ||
        !this.adTemp.adId ||
        String(query.id) !== String(this.adTemp.adId) ||
        !this.settings.isSettingsLoaded
      ) {
        Toast.failed(`${this.$t('error.occur')}${this.$t('error.para')}`);
        return this.$router.back();
      }
      this.adId = query.id;
    }
  },
  mounted() {
    let promise = Promise.resolve();
    if (!this.isEdit && !this.settings.isSettingsLoaded) {
      Toast.loading(this.$t('common.loading'));
      promise = this.$store.dispatch('updateSettings');
    }
    promise
      .then(() => {
        Toast.hide();
        this.title = this.adTemp.title;
        this.provisions = this.adTemp.provisions;
        this.isLoaded = true;
        // 默认交易对象补上
        // const traders = this.adTemp.traders.slice();
        // this.settings.property.forEach(item => {
        //   if (item.default && traders.indexOf(item.id) == -1) {
        //     traders.push(item.id);
        //   }
        // });
        // this.$store.commit('setCreateTemp', { traders });
        let scrollTop = +window.localStorage.getItem('createScrollTop');
        window.localStorage.removeItem('createScrollTop');
        !!scrollTop &&
          this.$refs.scrollView &&
          this.$refs.scrollView.scrollTo(0, scrollTop);
      })
      .catch(err => {
        Toast.hide();
        Toast.failed(`${this.$t('error.occur')}${err.message}`);
      });
  },
  beforeRouteLeave(to, from, next) {
    if (
      [
        '/post/create/setPrice',
        '/post/create/setPriceLimit',
        '/post/create/setActivityTime',
        '/post/create/setTrader',
      ].includes(to.path)
    ) {
      this.$store.commit('setCreateTemp', {
        title: this.title,
        provisions: this.provisions,
      });
      next();
    } else {
      if (!this.needQuitDialog) {
        this.$store.commit('setCreateTemp', { isNew: true });
        this.$store.commit('setAdStore', { isNew: true });
        return next();
      }
      const temp = this.adTemp;
      const store = this.adStore;
      let isChanged = false;
      for (let k in temp) {
        if (
          temp.hasOwnProperty(k) &&
          (k != 'title' || k != 'provisions') &&
          temp[k] !== store[k]
        ) {
          isChanged = true;
          break;
        }
        if (k == 'title' && store.title !== this.title) {
          isChanged = true;
          break;
        }
        if (k == 'provisions' && store.provisions !== this.provisions) {
          isChanged = true;
          break;
        }
      }
      if (isChanged) {
        return Dialog.confirm({
          icon: 'warn',
          title: this.$t('createPost.quitContent', {
            action: this.isEdit
              ? this.$t('createPost.quitEditing')
              : this.$t('createPost.quitPosting'),
          }),
          cancelText: this.$t('common.cancel'),
          confirmText: this.$t('createPost.quit'),
          onConfirm: () => {
            this.$store.commit('setCreateTemp', { isNew: true });
            this.$store.commit('setAdStore', { isNew: true });
            next();
          },
          onCancel: () => {
            next(false);
          },
        });
      } else {
        this.$store.commit('setCreateTemp', { isNew: true });
        this.$store.commit('setAdStore', { isNew: true });
        next();
      }
    }
  },
  methods: {
    getText(key) {
      return this[key];
    },
    showOptions(key) {
      switch (key) {
        case 'adType':
          this.hasFilter = false;
          this.showPopup(key);
          break;
        case 'fiatCurrency':
          this.hasFilter = true;
          this.showPopup(key);
          break;
        case 'location':
          this.hasFilter = true;
          this.showPopup(key);
          break;
        case 'crypto':
          this.hasFilter = true;
          this.showPopup(key);
          break;
        case 'attribute':
          this.hasFilter = false;
          this.showPopup(key);
          break;
        case 'payment':
          // this.selectedTemp = this.adTemp.payment.slice();  //这种情况是保留已选的
          this.selectedTemp = [];  //如果点进来选就先清空
          this.isShowPayMethodPopup = true;
          this.hasFilter = true;
          break;
        case 'customizePrice':
          this.hasFilter = false;
          if (!this.cryptoText || !this.fiatCurrencyText) {
            return Toast.info(this.$t('createPost.setPriceAlert'));
          }
          this.saveScrollTop();
          this.$router.push({
            path: '/post/create/setPrice',
            query: {
              fiatCurrencyId: this.adTemp.fiatCurrency,
              cryptoId: this.adTemp.crypto,
            },
          });
          break;
        case 'tradeAmount':
          this.hasFilter = false;
          if (!this.fiatCurrencyText) {
            return Toast.info(this.$t('createPost.setAmountAlert'));
          }
          if (!this.customizePriceText) {
            return Toast.info(this.$t('createPost.setPriceFirstAlert'));
          }
          this.saveScrollTop();
          this.$router.push('/post/create/setPriceLimit');
          break;
        case 'standardHours':
          this.hasFilter = false;
          this.saveScrollTop();
          this.$router.push('/post/create/setActivityTime');
          break;
        case 'trader':
          this.hasFilter = false;
          this.saveScrollTop();
          this.$router.push('/post/create/setTrader');
          break;
      }
    },
    showPopup(key) {
      let { name, title, list, value } = {};
      name = key;
      title = this.$t(`createPost.${key}`);
      list = this[`${key}List`];
      value = this.adTemp[key];
      this.popupData = {
        name,
        title,
        list,
        value,
      };
      this.$nextTick(() => {
        this.isShowPopup = true;
      });
    },
    hidePopup() {
      this.isShowPopup = false;
      this.filterKey = '';
    },
    onChoose(item) {
      const { value } = item;
      const { name } = this.popupData;
      this.popupData.value = value;
      const obj = {};
      obj[name] = value;
      if (name === 'fiatCurrency' && this.adTemp.fiatCurrency !== value) {
        // 修改法币类型，移除交易限制
        obj['isFixed'] = false;
        obj['fixedPrice'] = '';
        obj['reference'] = '';
        obj['isAbove'] = '';
        obj['percentage'] = '';
        obj['difference'] = '';
        obj['tradeAmountMin'] = '';
        obj['tradeAmountMax'] = '';
        obj['lowestPrice'] = '';
      }
      if (name === 'adType' && value === 'buy') {
        obj.isCheck = false;
      }
      this.$store.commit('setCreateTemp', obj);
      this.$nextTick(this.hidePopup);
    },
    saveScrollTop() {
      let scrollTop = Math.floor(this.$refs.scrollView.getOffsets().top);
      window.localStorage.setItem('createScrollTop', scrollTop);
    },
    goKyc() {
      this.$router.push('/mine/kyc');
    },
    onAgreeChange(checked) { //下单前同意风险及用户条例
      this.agreeConf.checked = checked;
    },
    onLossConfirm() { //风险弹窗确认按钮
      if(this.agreeConf.checked == true){
        this.lossDialog.open = false;
        this.onSaveBtnClick();
      }
    },
    onSaveBtnClickPre() {
      //添加主网资产受损弹窗
      this.lossDialog.open = true;
      return;
    },
    onSaveBtnClick() {
      
      const {
        adType: type,
        crypto: asset_id,
        payment: pay_method_ids,
        fiatCurrency: legal_currency_id,
        location: location_id,
        isFixed,
        fixedPrice: price,
        isAbove: is_above,
        percentage,
        tradeAmountMin: min_price,
        tradeAmountMax: max_price,
        timeZone,
        timeStart: ontime_start,
        timeEnd: ontime_end,
        difference: price_gap,
        reference,
        attribute,
        traders: property,
        lowestPrice,
        isCheck,
      } = this.adTemp;
      let promise = Promise.resolve();
      if (type === 'sell' && !isCheck) {
        promise = new Promise((resolve, reject) => {
          Dialog.confirm({
            icon: 'icon-negative',
            iconSvg: true,
            content: this.$t('error.optionalMode'),
            confirmText: this.isEdit
              ? this.$t('common.save')
              : this.$t('post.name'),
            cancelText: this.$t('common.back'),
            onConfirm: resolve,
            onCancel: reject,
          });
        });
      }
      promise
        .then(() => {
          this.isSubmitting = true;
          Toast.loading(this.$t('common.loading'));
          const langObj = {
            'zh-cn': 'zh-CN',
            en: 'en',
          };
          const lang = langObj[this.navLang] || 'en';
          const curr_type = (
            this.settings.referenceList.find(item => item.id == reference) || {}
          ).value;
          let newParams = {
            type,
            asset_id,
            pay_method_ids,
            legal_currency_id,
            location_id,
            min_price,
            max_price,
            zone: timeZone - 12,
            ontime_start,
            ontime_end,
            title: this.title,
            description: this.provisions,
            lang,
            attribute,
            lowest_price: lowestPrice || 0,
            is_check: +isCheck,
          };
          if (property.length) {
            newParams.property = property.slice();
          }
          let options = {};
          if (isFixed) {
            options = {
              is_curr: false,
              price,
            };
          } else {
            options = {
              is_curr: true,
              is_above,
              curr_type,
            };
            if (curr_type === 'exinone') {
              options.price_gap = price_gap;
            } else {
              options.percentage = percentage;
            }
          }
          Object.assign(newParams, options);
          if (this.isEdit) {
            putAdEdit(this.adId, newParams)
              .then(() => {
                Toast.hide();
                this.$nextTick(() => {
                  this.isSubmitting = false;
                  this.needQuitDialog = false;
                  this.$router.back();
                });
              })
              .catch(err => {
                this.isSubmitting = false;
                Toast.hide();
                const settingPageNum = [1030,1044,1095,1099,1144,1195];
                // if (err.code == '1044' || err.code === '1047') {
                if(settingPageNum.includes(err.code)){
                
                  return Dialog.failed({
                    title: err.message,
                    cancelText: this.$t('common.cancel'),
                    confirmText: this.$t('exchange.goKyc'),
                    onConfirm: () => {
                      this.goKyc();
                    },
                  });
                }
                Dialog.alert({
                  icon: 'warn-color',
                  title: err.message,
                  confirmText: this.$t('common.known'),
                });
              });
          } else {
            postNewAd(newParams)
              .then(() => {
                Toast.hide();
                Toast.succeed(this.$t('createPost.createSuccess'));
                this.needQuitDialog = false;
                this.$nextTick(() => {
                  this.isSubmitting = false;
                  this.$router.back();
                });
              })
              .catch(err => {
                this.isSubmitting = false;
                Toast.hide();
                const settingPageNum = [1030,1044,1095,1099,1144,1195];
                // if (err.code == '1044' || err.code === '1047') {
                if(settingPageNum.includes(err.code)){
                
                  return Dialog.failed({
                    title: err.message,
                    cancelText: this.$t('common.cancel'),
                    confirmText: this.$t('exchange.goKyc'),
                    onConfirm: () => {
                      this.$router.push('/mine/payInfo');
                    },
                  });
                }
                Dialog.alert({
                  icon: 'warn-color',
                  title: err.message,
                  confirmText: this.$t('common.known'),
                });
              });
          }
        })
        .catch(() => {});
    },
    onRemoveBtnClick() {
      Dialog.confirm({
        icon: 'warn',
        title: this.$t('createPost.removeContent'),
        cancelText: this.$t('common.cancel'),
        confirmText: this.$t('common.remove'),
        onConfirm: () => {
          Toast.loading(this.$t('common.loading'));
          this.isRemoving = true;
          putChangeStatus(this.adId, 'deleted')
            .then(() => {
              this.isRemoving = false;
              this.needQuitDialog = false;
              Toast.hide();
              Toast.succeed(this.$t('createPost.removeSuccess'));
              this.$router.replace('/post');
            })
            .catch(err => {
              this.isRemoving = false;
              Toast.hide();
              Dialog.alert({
                title: this.$t('error.occurs'),
                content: err.message,
                confirmText: this.$t('common.confirm'),
              });
            });
        },
      });
    },
    onPayMethodPopupCancel() {
      this.isShowPayMethodPopup = false;
      this.selectedTemp = [];
      this.filterKey = '';
    },
    onPayMethodPopupConfirm() {
      this.$store.commit('setCreateTemp', { payment: this.selectedTemp });
      this.onPayMethodPopupCancel();
    },
    onChoosePayment(selected) {
      this.$nextTick(() => {
        if (selected.length > 3) {
          Dialog.alert({
            title: this.$t('common.notice'),
            content: this.$t('common.choosePass3'),
            confirmText: this.$t('common.confirm'),
          });
          this.selectedTemp = selected.slice(0, 3);
        }
      });
    },
    onSwitchChange() {
      const { adType, isCheck } = this.adTemp;
      if (!isCheck && adType !== 'sell') {
        return Toast.info(this.$t('createPost.onlyForSell'));
      }
      this.$store.commit('setCreateTemp', { isCheck: !isCheck });
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  position: absolute;
  absolute-pos(11.73vw);
}

.scroll-body {
  padding-bottom: 60vw;
}

.search {
  width: 96%;
  height: 80px;
  line-height: 80px;
  // background-color: #fff;
  margin-left: 2%;
  border-radius: 10px;

  .search-icon {
    margin-left: 10px;
  }
}

.field {
  padding: 6.4vw 0;

  .field-item {
    padding: 0 4.8vw;
    height: 17.07vw;
    font-size: 3.73vw;

    &:nth-child(even) {
      background: #f8fbfc;
    }

    .field-item-title {
      flex: 0 0 32vw;
      font-weight: bold;
    }

    .field-item-content {
      width: 58.4vw;
      text-align: right;
      color: #1b6fdc;
      word-ellipsis();

      &.inactive {
        color: #bcc7cb;
      }
    }

    &.add-switch {
      height: auto;

      & > .row-justify-center {
        height: 17.07vw;
      }

      .switch {
        .brief {
          padding-top: 2.13vw;
          font-size: 3.2vw;
          color: #84969C;
        }

        & > .row-justify-center {
          height: 17.07vw;
        }
      }

      .md-switch {
        pointer-events: none;
      }
    }
  }
}

.input-panel {
  padding: 4.8vw 4.8vw 30vw;

  .input-panel-item {
    margin-bottom: 9.6vw;
  }

  .panel-item-title {
    margin-bottom: 4.8vw;
    font-size: 4.8vw;
    font-weight: bold;

    .icon {
      margin-right: 1.07vw;
      icon-size(6.67vw);
    }
  }

  >>> .md-field-item-content:before {
    content: none;
  }

  .input-item {
    border: 0.27vw solid #eaf1f3;
    padding: 0 2.13vw;
    border-radius: 2.67vw;
    background: #f8f8fc;
  }

  .textarea-item {
    padding: 3.2vw 2.13vw;
    border: 0.27vw solid #eaf1f3;
    border-radius: 2.67vw;
    background: #f8f8fc;
  }
}

.btn-wrapper {
  position: fixed;
  z-index: 100;
  left: 4.8vw;
  right: 4.8vw;
  bottom: 6.4vw;
  margin-bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
  margin-bottom: env(safe-area-inset-bottom); /* iOS 11.2 */

  .btn:not(:first-child) {
    margin-top: 4.8vw;
  }

  .btn-remove, .btn-on, .btn-off {
    background: #fff;
  }
}

.popup {
  .title-bar {
    border-bottom: 0.27vw solid #eaf1f3;

    >>> .title-bar-left, >>> .title-bar-right {
      width: 30%;
    }
  }

  .popup-body {
    padding-bottom: 10vw;
    height: 80vw;
    overflow-y: auto;
    background: #fff;

    & >>> {
      .md-cell-item-body {
        min-height: 12.8vw;
        padding-left: 4.8vw;
        padding-right: 4.8vw;
      }

      .md-icon {
        font-size: 5.33vw;
        color: color-primary;
      }
    }
  }

  .popup-item {
    height: 12.8vw;
    margin: 0 6.4vw;
    font-size: 4.27vw;

    &.active {
      color: color-primary;
    }
  }
}

.filter {
  padding: 4.8vw;
  background: #ffffff;

  .md-input-item {
    border: 0.27vw solid #eaf1f3;
    padding: 0 2.67vw;
    border-radius: 2.67vw;
    background: #f8fbfc;

    & >>> {
      .md-field-item-content:before {
        content: none;
      }

      .md-field-item-left {
        margin-right: 5.33vw;
        color: #B4C2C7;
      }
    }
  }
}

.scroller {
  box-sizing: border-box;
  width: 100%;
  height: 100vw;
  overflow: hidden auto;
  background: #fff;
}
</style>
